import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

/** Bağlantı kesildiğinde uygulama gibi kalıcı bilgi bandı gösterir. */
export const OfflineBanner = () => {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (!offline) return null;
  return (
    <div
      data-testid="offline-banner"
      style={{
        zIndex: "var(--z-toast)",
        bottom: "calc(var(--mobile-bottom-nav-height) + env(safe-area-inset-bottom))",
      }}
      className="fixed left-0 right-0 flex items-center justify-center gap-2 bg-primary px-4 py-2 text-xs font-semibold text-primary-foreground"
    >
      <WifiOff className="h-4 w-4" />
      İnternet bağlantısı yok — son açtığınız sayfalar görüntülenebilir
    </div>
  );
};
